/**
 * Formats a value to mileage adding a dot, normalizing decimals and add unit
 *
 * @param {number} value
 * @returns {string}
 */
export const formatMileage = value => {
    let formatter = new Intl.NumberFormat('fr-FR', {
        style: 'unit',
        unit: 'kilometer',
        minimumFractionDigits: 0,
    });

    return formatter.format(parseFloat(value));
}
